export const APIConstants: any = {
	'LOGIN': 'login',
	'FORGOT_PASSWORD': 'forgotpassword',
	// 'LOGOUT': 'logout',
	'LOGOUT': 'https://ttlprodapim.azure-api.net/logout',
	'UPLOAD': 'upload',
	'UPLOADSCRUBBING': 'https://ttlprodapim.azure-api.net/upload',
	'INVOKE': 'https://ttlprodapim.azure-api.net/invoke',
	'GETSUBSCRIBERANDPREFERENCEDETAILS': 'https://ttlprodapim.azure-api.net/query/GetSubscriberAndPreferenceDetails/',
	//'FILEDOWNLOAD': 'https://ttlprodapim.azure-api.net/fileDownload',
	'GETALLENTITYFORAPPROVAL': 'https://ttlprodapim.azure-api.net/query/GetAllEntityForApproval/',
	'GETALLENTITYFORAPPROVALFILTER': 'https://ttlprodapim.azure-api.net/query/GetAllEntityForApprovalUSingSearch/',
	'UPDATEENTITYDETAILSMONGO': 'https://ttlprodapim.azure-api.net/updateEntityDetails',
	'GETENTITYSUMMARY': 'https://ttlprodapim.azure-api.net/query/GetEntitySummary/',
	'GETENTITYSUMMARYMONGO': 'https://ttlprodapim.azure-api.net/newGetEntitySummaryMongo',
	'VALIDATEENTITYID': 'https://ttlprodapim.azure-api.net/query/CheckEntityExistance/',
	'GETALLENTITYFILTER': 'https://ttlprodapim.azure-api.net/query/GetEntitySummaryUsingFilter/',
	'INVITEUSER': 'https://ttlprodapim.azure-api.net/inviteUser',
	'IMPORTPREFERENCE': 'https://ttlprodapim.azure-api.net/importPreference',
	'PREFERNCESUMMARY': 'https://ttlprodapim.azure-api.net/preferenceSummary',
	'IMPORTCOMPLAINTS': 'https://ttlprodapim.azure-api.net/importComplaints',
	'IMPORTTEMPLATE': 'https://ttlprodapim.azure-api.net/importTemplate',
	'IMPORTHEADER': 'https://ttlprodapim.azure-api.net/importHeader',
	'GETPREFERENCESUMMARYFILTER': 'https://ttlprodapim.azure-api.net/PreferenceSummaryFilters',
	//'PREFERENCEDOWNLOAD':'https://ttlprodapim.azure-api.net/PreferenceDownload', 
	'PREFERENCEDOWNLOAD': 'https://ttlprodapim.azure-api.net/PreferenceDownload',
	// 'PREFERENCEDOWNLOAD':'https://ttlprodapim.azure-api.net/tops/downloadFile?file=', 
	'DOWNLOADFILE': 'https://ttlprodapim.azure-api.net/tops/downloadFile',
	'DOWNLOADFILEPREFERENCE': 'https://ttlprodapim.azure-api.net/downloadFile',
	'GETCATEGORY': 'https://ttlprodapim.azure-api.net/query/GetAllPreferenceCategories',
	//'LOGINMONGO': 'https://ttlprodapim.azure-api.net/login',
	'LOGINMONGO': 'https://ttlprodapim.azure-api.net/login',

	'VERIFYOTPFP': 'https://ttlprodapim.azure-api.net/verifyOTPFP',
	'UPDATEPASSWORD': 'https://ttlprodapim.azure-api.net/updatePassword',
	//'GENERATEOTPFORGOTPASSWORD': 'https://ttlprodapim.azure-api.net/generateOTPForgotPwd',




	'ENTITYREGISTER': 'https://ttlprodapim.azure-api.net/entityRegister',
	'ENTITYREGISTERNOTIFICATION': 'https://ttlprodapim.azure-api.net/sendNotifications',
	'OTPNOTIFICATION': 'https://ttlprodapim.azure-api.net/sendOTPNotifications',
	//'GENERATEOTP': 'https://ttlprodapim.azure-api.net/subscriber/generateOTP',
	'PREFERENCENCPRDETAILS': 'https://ttlprodapim.azure-api.net/preferenceSummaryDetails',

	'FAILUREFILEDOWNLOAD': 'https://ttlprodapim.azure-api.net/preferenceFailedDetails',
	//'VERIFYOTP': 'https://ttlprodapim.azure-api.net/subscriber/verifyOTP',
	'DEACTIVATEENTITY': 'https://ttlprodapim.azure-api.net/blackListEntity',
	//'FETCHENTITYDETAILS': 'https://ttlprodapim.azure-api.net/getExistingEntityDetails',
	//'GENERATEOTPENTITY': 'https://ttlprodapim.azure-api.net/generateOTP',
	//'VERIFYOTPENTITY': 'https://ttlprodapim.azure-api.net/verifyOTP',

	'BADWORDSDATA': 'https://ttlprodapim.azure-api.net/postBadWords',
	'BADWORDSDATACHECK': 'https://ttlprodapim.azure-api.net/searchMatchingWord',
	'GETALLRESTRICTEDWORDS': 'https://ttlprodapim.azure-api.net/searchMatchingWordGet',
	'DELETERESTRICTEDWORDS': 'https://ttlprodapim.azure-api.net/deletingRestrictedWords',
	'UPLOADRESTRICTEDWORDS': 'https://ttlprodapim.azure-api.net/uploadRestrictedWords',
	'LISTHEADERVOICE': 'https://ttlprodapim.azure-api.net/ListHeaderVoice',
	'REGISTERHEADERVOICE': 'https://ttlprodapim.azure-api.net/RegisterHeaderVoice',
	'UPDATESTATUSHEADERVOICE': 'https://ttlprodapim.azure-api.net/UpdateStatusHeaderVoice',
	'LISTPRICIPLEENTITYHEADERVOICEDLT': 'https://ttlprodapim.azure-api.net/ListPricipalEntityHeaderVoiceDLT',
	'LISTHEADERVOICEDLT': 'https://ttlprodapim.azure-api.net/ListHeaderVoiceDLT',
	'LISTTELEMARKETERENTITYHEADERVOICE': 'https://ttlprodapim.azure-api.net/ListTelemarketerEntityHeaderVoice',
	'LISTTELEMARKETERENTITYHEADERVOICEDLT': 'https://ttlprodapim.azure-api.net/ListTeleEntityHeaderVoiceDLT',
	'LISTPRICIPLEENTITYHEADERVOICE': 'https://ttlprodapim.azure-api.net/ListPrincipalEntityHeaderVoice',
	'LISTTELEENTITYHEADERSMSDLT': 'https://ttlprodapim.azure-api.net/listTeleEntityHeaderSMSDLT',
	'GETALLPRINCIPALENTITY': 'https://ttlprodapim.azure-api.net/GetAllPricipalEntity',

	'ROOTHEADERUPLOAD': 'https://ttlprodapim.azure-api.net/RegisterRootHeaderSMS',
	'UPDATESTATUSROOTHEADER': 'https://ttlprodapim.azure-api.net/UpdateStatusRootHeaderSMS',
	'UPDATESTATUSHEADERSMS': 'https://ttlprodapim.azure-api.net/UpdateStatusHeaderSMS',
	'LISTROOTHEADERSMS': 'https://ttlprodapim.azure-api.net/ListRootHeaderSMS',
	'LISTHEADERSMS': 'https://ttlprodapim.azure-api.net/ListHeaderSMS',
	'LISTENTITYROOTHEADERSMS': 'https://ttlprodapim.azure-api.net/ListEntityRootHeaderSMS',
	'REGISTERHEADER': 'https://ttlprodapim.azure-api.net/RegisterHeaderSMS',
	'LISTPRINCIPLEENTITYHEADERSMSDLT': 'https://ttlprodapim.azure-api.net/ListPricipalEntityHeaderSMSDLT',
	'LISTPRINCIPLEENTITYHEADERSMS': 'https://ttlprodapim.azure-api.net/listPricipalEntityHeaderSMS',
	'LISTPRINCIPALENTITYSMS': 'https://ttlprodapim.azure-api.net/listPrincipalEntityHeaderSMS',
	'LISTTELEMARKETERHEADERSMS': 'https://ttlprodapim.azure-api.net/listTelemarketerEntityHeaderSMS',
	'LISTHEADERSMSDLT': 'https://ttlprodapim.azure-api.net/ListHeaderSMSDLT',

	'COMPLAINTSDOWNLOAD': 'https://ttlprodapim.azure-api.net/downloadComplaintsCh',
	'COMPLAINTSUPLOADTAP': 'https://ttlprodapim.azure-api.net/complaints/bulkUpload/tap',
	'COMPLAINTSUPLOADOAP': 'https://ttlprodapim.azure-api.net/complaints/bulkUpload/oap',
	'IMPORTCOMPLAINTSUMMARY': 'https://ttlprodapim.azure-api.net/ComplaintsNCPRSummary',
	'COMPLAINTSNCPRDETAILS': 'https://ttlprodapim.azure-api.net/ComplaintsData',
	'GETENTITYDETAILS': 'https://ttlprodapim.azure-api.net/headerEntitySummary',
	'GETHEADERDETAILS': 'https://ttlprodapim.azure-api.net/getHeaderDetails',

	'DOWNLOADENTITYDETAILS': 'https://ttlprodapim.azure-api.net/downloadentitydetails',
	'DOWNLOADHEADERDETAILS': 'https://ttlprodapim.azure-api.net/downloadheaderdetails',
	'DOWNLOADROOTHEADERDETAILS': 'https://ttlprodapim.azure-api.net/downloadrootheaderdetails',
	'DOWNLOADHEADERDETAILSDLT': 'https://ttlprodapim.azure-api.net/downloadheaderdetailsdlt',
	'GETENTITYSUMMARYMONGOTA': 'https://ttlprodapim.azure-api.net/newGetEntitySummaryMongoExceptTa',
	'GETENTITYNAMEDETAILS': 'https://ttlprodapim.azure-api.net/getEntityNameDetails',

	'SENDOPT': 'https://ttlprodapim.azure-api.net/send_otp',
	'SETPREFERENCE': 'https://ttlprodapim.azure-api.net/setPreference',
	//'GETREGISTEREDDETAILS': 'https://ttlprodapim.azure-api.net/getRegisteredDetails',
	//'UPDATEENTITY': 'https://ttlprodapim.azure-api.net/updateEntity',
	//'RESENDEmailSmsOTP': 'https://ttlprodapim.azure-api.net/resendEmailSmsOTP',
	'DOWNLOADPREFFAQ': 'https://ttlprodapim.azure-api.net/downloadPrefFAQ',
	'GETSRVAC': 'https://ttlprodapim.azure-api.net/getSrvac',
	'REGMAIL': 'https://ttlprodapim.azure-api.net/regmail',
	'CONTENTENTITYREGISTRATION': 'https://ttlprodapim.azure-api.net/ContentEntityRegistration',
	'GETCONTENTENTITYDETAILS': 'https://ttlprodapim.azure-api.net/getContentEntityDetails',
	'TEMPLATEFILEDOWNLOAD': 'https://ttlprodapim.azure-api.net/templatefiledownload',
	'GETTEMPLATEDETAILS': 'https://ttlprodapim.azure-api.net/getTemplateDetails',
	'CONTENTENTITYMODIFICATION': 'https://ttlprodapim.azure-api.net/ContentEntityModification',
	'GETTEMPLATESUMMARYFILTER': 'https://ttlprodapim.azure-api.net/getTemplateSummaryFilter',
	'DOWNLOADTEMPLATES': 'https://ttlprodapim.azure-api.net/downloadTemplates',
	'VERIFYCSTEMPID': 'https://ttlprodapim.azure-api.net/verifyCsTempID',
	'GETTEMPLATESUMMARYMONGO': 'https://ttlprodapim.azure-api.net/getTemplateSummaryMongo',

	'CONTENTBULKUPLOAD': 'https://ttlprodapim.azure-api.net/importBulkContentRegistration',
	'DOWNLOADCSTBULKUPLOAD': 'https://ttlprodapim.azure-api.net/downloadBulkContentUploadSummary',
	'CONSENTBULKSUMMARYFILTER': 'https://ttlprodapim.azure-api.net/getContentBulkUploadSummaryFilter',
	'GETCTBULKUPLOADSUMMARY': 'https://ttlprodapim.azure-api.net/getContentBulkUploadSummaryAll',


	'GETCSTNEWTEMPLATEREQUEST': 'https://ttlprodapim.azure-api.net/getCSTByURN',
	'POSTCSTNEWTEMPLATEREQUEST': 'https://ttlprodapim.azure-api.net/CSTRegistration',

	'GETCSBULKUPLOADSUMMARY': 'https://ttlprodapim.azure-api.net/getBulkUploadSummaryAll',
	'GETCSBULKUPLOADSUMMARYFILTERS': 'https://ttlprodapim.azure-api.net/getBulkUploadSummaryFilter',
	'DOWNLOADCONSENTBULKSUMMARYSSVFILE': 'https://ttlprodapim.azure-api.net/downloadBulkUploadSummary',

	'GETCSTEMPLATEREPORTS': 'https://ttlprodapim.azure-api.net/getCSTAllReport',
	'GETCSTEMPLATEREPORTSFILTERS': 'https://ttlprodapim.azure-api.net/getCSTReport',
	'DOWNLOADTEMPLATEREPORTSSSVFILE': 'https://ttlprodapim.azure-api.net/downloadCSTReport',
	'GETENTITYCONSENTTEMPLATE': 'https://ttlprodapim.azure-api.net/getCSTByURN',
	'POSTENTITYCONSENTTEMPLATE': 'https://ttlprodapim.azure-api.net/updateCST',

	'IMPORTBULKCSTREGISTRATION': 'https://ttlprodapim.azure-api.net/importBulkCSTRegistration',
	'GETCONSENTTEMPLATE': 'https://ttlprodapim.azure-api.net/bulkUploadSchema',

	//Header
	'FETCHENTITYINHEADTEMPTALE': 'https://ttlprodapim.azure-api.net/fetchEntityInHeadTempTable',
	'FETCHDLTENTITYDETAILS': 'https://ttlprodapim.azure-api.net/fetchDltEntityDetails',
	'FETCHINDUSTRYDETAILSFROMDB': 'https://ttlprodapim.azure-api.net/fetchIndustryDetailsFromDB',
	'CHECKAVAILABILTYHEADER': 'https://ttlprodapim.azure-api.net/checkAvailabilityHeader',
	'UPDATEMOBILEEMAILINMONGO': 'https://ttlprodapim.azure-api.net/updateMobileEmailInMongo',
	'SENDEMOTPFORHEADER': 'https://ttlprodapim.azure-api.net/sendEMOTPForHeader',
	'RESENDOTPHEADER': 'https://ttlprodapim.azure-api.net/resendOTPForHeader',
	'REGISTERHEADERNEW': 'https://ttlprodapim.azure-api.net/RegisterHeaderSMSNew',
	'GETONEENTITYDROMMONGO': 'https://ttlprodapim.azure-api.net/getOneEntityFromMongo',
	'GETONEHEADERFOMMONGO': 'https://ttlprodapim.azure-api.net/getOneHeaderFromMongo',
	'GETHEADERSBYPE': 'https://ttlprodapim.azure-api.net/headersbype',
	'DOWNLOADPEHEADERREPORTS': 'https://ttlprodapim.azure-api.net/downloadPEHeaderReports',
	'SEARCHPEHEADERREPORTS': 'https://ttlprodapim.azure-api.net/searchPEHeaderReports',

	'DOWNLOADHEADERFILE': 'https://ttlprodapim.azure-api.net/downloadHeaderFile',
	'BULKUPLOADSCHEMA': 'https://ttlprodapim.azure-api.net/bulkUploadSchema',
	'GETBULKHEADERSUMMARY': 'https://ttlprodapim.azure-api.net/getBulkHeaderSummary',
	'GETBULKHEADERSUMMARYFILTER': 'https://ttlprodapim.azure-api.net/getBulkHeaderSummaryFilter',


	'FETCHTMNAME': 'https://ttlprodapim.azure-api.net/fetchTMName',
	'UPDATEMOBILEEMAILINMONGOMODIFY': 'https://ttlprodapim.azure-api.net/updateMobileEmailInMongoModify',
	'MODIFYHEADER': 'https://ttlprodapim.azure-api.net/modifyHeader',
	'MODIFYMOBILEEMAILINMONGO': 'https://ttlprodapim.azure-api.net/modifyMobileEmailInMongo',
	'HEADERBULKDETAILS': 'https://ttlprodapim.azure-api.net/headerBulkDetails',
	//'CHECKPOIEMAILMOBILE': 'https://ttlprodapim.azure-api.net/checkPOIEmailMobile',
	//'URNGENERATE': 'https://ttlprodapim.azure-api.net/urnGenerate',


	//Bulk Consent upload by PE

	'GETBULKCONSENTSUMMARY': 'https://ttlprodapim.azure-api.net/getConsentBulkUploadSummaryAll',
	'DOWNLOADCONSENTFILE': 'https://ttlprodapim.azure-api.net/downloadConsentFile',
	'GETCONSENTSUMMARYFILTER': 'https://ttlprodapim.azure-api.net/getConsentBulkUploadSummaryFilter',
	'GETQUERYTEMPLATEIDS': 'https://ttlprodapim.azure-api.net/queryTemplateId',
	'BULKCONSENTUPLOAD': 'https://ttlprodapim.azure-api.net/bulkConsentUpload',
	'CHECKCONSENTMIGFILESTS': 'https://ttlprodapim.azure-api.net/CheckConsentMigFileSts',
	'GETCSENTITYCONSENTREPORTS': 'https://ttlprodapim.azure-api.net/getPECSTReportsAll',
	'GETCSENTITYCONSENTREPORTSFILTERS': 'https://ttlprodapim.azure-api.net/getPECSTReportFilter',
	'DOWNLOADENTITYCONSENTREPORTSSSVFILE': 'https://ttlprodapim.azure-api.net/downloadPECSTReport',
	'CHECKIPONLOAD': 'https://ttlprodapim.azure-api.net/checkIPOnLoad',
	//'DOWNLOADDLTREPORT': 'https://ttlprodapim.azure-api.net/downloadDLTReport',




	//Entity-PhaseI
	'GETAUDITLOG': 'https://ttlprodapim.azure-api.net/getAuditLog',
	//'MODIFYFILEDOWNLOAD': 'https://ttlprodapim.azure-api.net/modifyFileDownload',
	'GETEDITLOG': 'https://ttlprodapim.azure-api.net/getEditLog',
	'RESENDOTPchange': 'https://ttlprodapim.azure-api.net/resendOTPchange',
	'changePWdVerification': 'https://ttlprodapim.azure-api.net/changepwdverification',
	'PEWCHANGE': 'https://ttlprodapim.azure-api.net/pwdChange',

	'RESENDEmailSmsOTP': 'https://ttlprodapim.azure-api.net/resendEmailSmsOTP',
	'FORGOTPEWCHANGE': 'https://ttlprodapim.azure-api.net/forgotPwdChange',
	'GENERATEOTPFORGOTPASSWORD': 'https://ttlprodapim.azure-api.net/generateOTPForgotPwd',
	'GETPROCESSROLES': 'https://ttlprodapim.azure-api.net/getProcessRoles',
	'FETCHENTITYDETAILS': 'https://ttlprodapim.azure-api.net/getExistingEntityDetails',
	'TATAENTITYREGISTER': 'https://ttlprodapim.azure-api.net/tata-entityRegister',
	'GETPROCESSROLESMODIFY': 'https://ttlprodapim.azure-api.net/getProcessRolesModify',
	'GETPROCESSOWNERDETAILS': 'https://ttlprodapim.azure-api.net/getProcessOwnerDetails',
	'FILEDOWNLOAD': 'https://ttlprodapim.azure-api.net/fileDownload',
	//'DELETEBLOBIFEXISTS': 'https://ttlprodapim.azure-api.net/deleteBlobIfExists',
	'TATAMODIFICATION': 'https://ttlprodapim.azure-api.net/tataModification',
	'DOWNLOADENTITYCSVFILE': 'https://ttlprodapim.azure-api.net/downloadentitycsvfile',
	'GETTTSLUSERSUMMARYFILTER': 'https://ttlprodapim.azure-api.net/getTtsluserSummaryFilter',
	'GETTATASUMMARYMONGO': 'https://ttlprodapim.azure-api.net/getTataSummaryMongo',
	'UPDATETATADETAILSMONGO': 'https://ttlprodapim.azure-api.net/updateTataDetails',
	'DOWNLOADTATAFILE': 'https://ttlprodapim.azure-api.net/downloadtatafile',
	'GETALLTATASUMMARYMONGO': 'https://ttlprodapim.azure-api.net/getAllTataSummaryMongo',
	'TATALOGINMONGO': 'https://ttlprodapim.azure-api.net/tatalogin',
	'GETGETTLUSERDETAILS': 'https://ttlprodapim.azure-api.net/geTTLUserDetails',
	'POSTMODIFYSTATUS': 'https://ttlprodapim.azure-api.net/modifyStatus',
	'LOGINMONGOTMPE': 'https://ttlprodapim.azure-api.net/loginTMPE',
	'COMMONLOGINTMPE': 'https://ttlprodapim.azure-api.net/loginTMPE',
	'GENERATEOTP': 'https://ttlprodapim.azure-api.net/subscriber/generateOTP',
	'GENERATEOTPENTITY': 'https://ttlprodapim.azure-api.net/generateOTP',
	'VERIFYOTP': 'https://ttlprodapim.azure-api.net/subscriber/verifyOTP',
	'VERIFYOTPENTITY': 'https://ttlprodapim.azure-api.net/verifyOTP',
	'VERIFYOTPENTITYPETM': 'https://ttlprodapim.azure-api.net/verifyOTPEntityPeTm',
	'TMPEENTITYUPDATION': 'https://ttlprodapim.azure-api.net/TMPEEntityUpdation',
	'GETPETMENTITYDETAILS': 'https://ttlprodapim.azure-api.net/getPETMEntityDetails',
	'GETDETAILSFROMURN': 'https://ttlprodapim.azure-api.net/getDetailsFromURN',
	'GETEXISTINGID': 'https://ttlprodapim.azure-api.net/getExistingID',
	'CHECKPOINECLASS': 'https://ttlprodapim.azure-api.net/checkPOInEclass',
	'SENDEMOTP': 'https://ttlprodapim.azure-api.net/sendEMOTP',
	'CHECKPOIEMAILMOBILE': 'https://ttlprodapim.azure-api.net/checkPOIEmailMobile',
	'URNGENERATE': 'https://ttlprodapim.azure-api.net/urnGenerate',
	'GETREGISTEREDPOI': 'https://ttlprodapim.azure-api.net/getRegisteredPOI',
	'GETALLSTATES': 'https://ttlprodapim.azure-api.net/getAllStates',
	'GETALLCITIESBYSTATENAME': 'https://ttlprodapim.azure-api.net/getCitiesByStateName',
	'DELETEBLOBIFEXISTS': 'https://ttlprodapim.azure-api.net/deleteBlobIfExists',
	'GETREGISTEREDDETAILS': 'https://ttlprodapim.azure-api.net/getRegisteredDetails',
	'GETENTITYDETAILSID': 'https://ttlprodapim.azure-api.net/getEntityDetailsID/',
	'CHECKPANEXISTS': 'https://ttlprodapim.azure-api.net/checkPanExists',
	'MODIFYFILEDOWNLOAD': 'https://ttlprodapim.azure-api.net/modifyFileDownload',
	'MODSENDEMOTP': 'https://ttlprodapim.azure-api.net/modSendEMOTP',
	'UPDATEENTITY': 'https://ttlprodapim.azure-api.net/updateEntity',
	'GETENTITYDETAILSURN': 'https://ttlprodapim.azure-api.net/getEntityDetailsUrn',
	'GETENTITYWORKLIST': 'https://ttlprodapim.azure-api.net/getEntityWorklist',
	'GETWORKLISTSUMMARYFILTER': 'https://ttlprodapim.azure-api.net/getWorklistSummaryFilter',
	'DOWNLOADENTITYWORKLISTCSVFILE': 'https://ttlprodapim.azure-api.net/downloadentityworklistcsvfile',
	'GETREPORTSUMMARYFILTER': 'https://ttlprodapim.azure-api.net/getReportSummaryFilter',
	'GETENTITYREPORT': 'https://ttlprodapim.azure-api.net/getEntityReport',
	'DOWNLOADREPORTCSVFILE': 'https://ttlprodapim.azure-api.net/downloadreportcsvfile',
	'REPORTFILEDOWNLOAD': 'https://ttlprodapim.azure-api.net/reportFileDownload',
	'BLACKLISTENTITYREPORT': 'https://ttlprodapim.azure-api.net/BlacklistEntityReport',
	'DOWNLOADDLTREPORT': 'https://ttlprodapim.azure-api.net/downloadDLTReport',
	'DOWNLOADDAILYREPORT': 'https://ttlprodapim.azure-api.net/downloadDailyReport',


	'SENDOTPMOBILE': 'https://ttlprodapim.azure-api.net/complaints/sendComplaintsOTP',
	'VERIFYDELNO': 'https://ttlprodapim.azure-api.net/complaints/verifyDelNumber',
	'VERIFYOTPMOBILE': 'https://ttlprodapim.azure-api.net/complaints/verifyComplaintsOTP',
	'COMPLAINTREG': 'https://ttlprodapim.azure-api.net/complaints/complaintsRegistration',
	
// observer dashboard
'ENTITYCOUNT': 'https://ttlprodapim.azure-api.net/getEntitycount',
'TELEMARKETERCOUNT': 'https://ttlprodapim.azure-api.net/getTeleMarketercount',
'HEADERCOUNT': 'https://ttlprodapim.azure-api.net/getHeadercount',
'CONTENTTEMPLATECOUNT': 'https://ttlprodapim.azure-api.net/getContentTemplatecount',
'PREFCOUNT': 'https://ttlprodapim.azure-api.net/getPreferencecount',
'CONSENTCOUNT' :'https://ttlprodapim.azure-api.net/getCSTcount',
'COMPLAINTCOUNT' :'https://ttlprodapim.azure-api.net/complaints/getDashBoard_AllComplaintsCount',
'COMGRAPH' :'https://ttlprodapim.azure-api.net/complaints/DashBoard_ComplaintsGraph/',


//Entity-Observer

'GETENTITYDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/getEntityDataForObserver',
'SEARCHENTITYDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/searchEntityDataForObserver',
'DOWNLOADENTITYDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/downloadEntityDataForObserver',

//TM-Observer

'GETTMDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/getTMDataForObserver',
'SEARCHTMDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/searchTMDataForObserver',
'DOWNLOADTMDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/downloadTMDataForObserver',

//Pref_Observer
'GETPREFERENCESFOROBSERVER': 'https://ttlprodapim.azure-api.net/getPreferencesForObserver',
'OBSERVERPREFERENCECOUNT': 'https://ttlprodapim.azure-api.net/ObserverPreferenceCount',



// Header-Observer
'GETHEADERDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/ObserverHeader',
'SEARCHHEADERFOROBSERVER': 'https://ttlprodapim.azure-api.net/filterObserverData',
'DOWNLOADHEADERDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/ObserverHeaderDownload',

// Consent-Obv
'GETCSTDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/getCSTDataForObserver',
'SEARCHCSTDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/searchCSTDataForObserver',
'DOWNLOADCSTDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/downloadCSTDataForObserver',

// Content-Obv
'GETCTDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/getTemplateDataForObserver',
'SEARCHCTDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/searchTemplateForObserver',
'DOWNLOADCTDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/downloadTemplateForObserver',

// Complaits-Obv
'SEARCHCOMPLAINTSFOROBSERVER': 'https://ttlprodapim.azure-api.net/complaints/getDashBoard_ComplaintsFilter',
'DOWNLOADCOMPLAINTSDATAFOROBSERVER': 'https://ttlprodapim.azure-api.net/complaints/downloadDashBoard_ComplaintsFilter',
'COMPLAINTSOBVCOMPREHENSIVERPT': 'https://ttlprodapim.azure-api.net/complaints/ComplaintsObvComprehensiveFilter',
'COMPLAINTSFOROBSERVERCOUNT': 'https://ttlprodapim.azure-api.net/complaints/complaintsObserverDataCount',
'DOWNLOADCOMPLAINTSOBVCOMPREHENSIVERPT': 'https://ttlprodapim.azure-api.net/complaints/downloadComplaintsObvComprehensiveRpt',
//IP Registration
'ADDNEWIP': 'https://ttlprodapim.azure-api.net/registerIPAddress',
'LISTIPADDRESS': 'https://ttlprodapim.azure-api.net/listIPAddress',
'DOWNLOADEXCEL': 'https://ttlprodapim.azure-api.net/exportIPregCSV',
'REMOVEIP': 'https://ttlprodapim.azure-api.net/updateIPAddress',
'ADDNEWURL': 'https://ttlprodapim.azure-api.net/registerCallbackURL',
'UPDATEDURL': 'https://ttlprodapim.azure-api.net/updateCallbackURL',

'GENERATETOKEN': 'https://ttlprodapim.azure-api.net/generateToken', //pradnya key based authentication

//Payment Dues
'DOWNLOADPAYMENTDUESEXCEL': 'https://ttlprodapim.azure-api.net/PaymentDueExport',
'PAYMENTDUES': 'https://ttlprodapim.azure-api.net/PaymentDue',

//Payment History
'DOWNLOADPAYMENTHISTORYEXCEL': 'https://ttlprodapim.azure-api.net/exportPaymentHistoryCSV',
'PAYMENTHISTORYINFO': 'https://ttlprodapim.azure-api.net/PaymentHistory',

//Payment Submit
'GSTNUMBYENTITY': 'https://ttlprodapim.azure-api.net/gstList',
'POSTDLTPAYMENTORDER' : 'https://ttlprodapim.azure-api.net/placeDLTPaymentOrder',
'GETDLTPAYMENTORDER' : 'https://ttlprodapim.azure-api.net/fetchDLTPaymentOrder',
//'POSTPAYMENTRESPONSE' : 'https://ttlprodapim.azure-api.net/ibppayresp',

'IBPPAYMENTRESPONSE' : 'https://ttlprodapim.azure-api.net/pay/ibppayresp',
'CHKPOIAVAILABILITY': 'https://ttlprodapim.azure-api.net/chkPOIAvailability',
'SECONDARYENTITYREG':'https://ttlprodapim.azure-api.net/updateSecondaryEntityReg',

//GST MODULE- GSTREGISTRATIONSEARCH
'GSTREGISTRATIONSEARCHDETAILS': 'https://ttlprodapim.azure-api.net/gst/get/registrationList',
'DOWNLOADGSTSEARCHEXCEL': 'https://ttlprodapim.azure-api.net/gst/download/registrationCsv',

//GST MODULE -NEW Registration': '
'NEWGSTREG': 'https://ttlprodapim.azure-api.net/gst/new/registration',
'VERIFYGSTREG': 'https://ttlprodapim.azure-api.net/gst/new/verifyRegistration',

//GST MODULE - MODIFY REGISTRATION': '
'MODIFYGSTREG': 'https://ttlprodapim.azure-api.net/gst/modify/registration',

//GST MODULE - RegistrationDetail': '
'GSTDETAILS': 'https://ttlprodapim.azure-api.net/gst/get/registrationDetails',
'GSTCERTIFICATE': 'https://ttlprodapim.azure-api.net/gst/get/certificate',

//consent linking-delinking
'VERIFYCST': 'https://ttlprodapim.azure-api.net/template/verifycst',	
'LINKCST': 'https://ttlprodapim.azure-api.net/template/linkcst',

//Consent Acquisition & consent acquisition through QR code
'ACQUIRECSREGTHRUPAGE': 'https://ttlprodapim.azure-api.net/acquireCSRegthruPage',
'VERIFYCSTID':'https://ttlprodapim.azure-api.net/verifyCstID',

'ACQUIRECSREGTHRUQR': 'https://ttlprodapim.azure-api.net/genqrcode',
'CONSENTQR':'https://ttlprodapim.azure-api.net/consentqr',
'PROCESSQRCD':'https://ttlprodapim.azure-api.net/processqrcode',
'SUBMITCONSENTFORQRCD':'https://ttlprodapim.azure-api.net/submitconsentforqrcode',
'SUMMARYFILTER':'https://ttlprodapim.azure-api.net/summaryFilter',
'DOWNLOADCONSENTSTATUSSUMMARYEXCEL' : 'https://ttlprodapim.azure-api.net/downloadFilter',
//Digital Consent Credits
'RECHARGESUMMARYFILTER':'https://ttlprodapim.azure-api.net/recharge-summaryFilter',
'FETCHCREDITBALANCE':'https://ttlprodapim.azure-api.net/fetch-creditbal',
'GETRATECARD':'https://ttlprodapim.azure-api.net/get-ratecard',
'BUYRATECARD':'https://ttlprodapim.azure-api.net/buy-ratecard',
'FETCHCSTID':'https://ttlprodapim.azure-api.net/fetchCSTID',		
	

//Non-ttl templates
'GETNONTTLTEMPLATES':'https://ttlprodapim.azure-api.net/getnonTTLTemplates',
'SEARCHNONTTLTEMPLATES':'https://ttlprodapim.azure-api.net/searchNonTTLTemplates',
'EXPORTNONTTLTEMPLATES':'https://ttlprodapim.azure-api.net/exportnonTTLTemplates',

//Consent-Obv 
	'FETCHCONSENT':'https://ttlprodapim.azure-api.net/fetchConsent',

//Helpdesk
'REQUESTREGISTRATION': 'https://ttlprodapim.azure-api.net/requestRegistration',
'GETREQUESTSDATA': 'https://ttlprodapim.azure-api.net/getRequestsData',
'REQUESTSWORKLISTFILTER': 'https://ttlprodapim.azure-api.net/requestsWorklistfilter',
'REQUESTRESOLUTION': 'https://ttlprodapim.azure-api.net/requestResolution',

//Added for Verify Header
'VERIFYHEADER':'https://ttlprodapim.azure-api.net/ReconcileHeaderByPE',
	
//Added for Verify Template
'VERIFYTEMPLATES':'https://ttlprodapim.azure-api.net/ReconcileContentTemplateByPE',

//Content Template Modification
'CONTENTTEMPLATECHANGE':'https://ttlprodapim.azure-api.net/TempContentModification',
'GETTEMPLATEFORPEID':'https://ttlprodapim.azure-api.net/getTemplateInfoForPE',

//BULKTEMPLATEVERIFICATION
'VERIFICATIONREPORT': 'https://ttlprodapim.azure-api.net/tmpVerificationReport',
'UPDATETMPVERIFICAATION': 'https://ttlprodapim.azure-api.net/updateTmpVerification',
'TMPVERIFICATIONSUMMARYREPORT': 'https://ttlprodapim.azure-api.net/tmpVerificationSummaryReport',	
'UPDATETMPVERIFICATIONSUMMARY': 'https://ttlprodapim.azure-api.net/updateTmpVerificationSummary',

//Header Conversion Extension

'TEMPORARYHEADEREXTENSION': 'https://ttlprodapim.azure-api.net/temporaryHeaderExtension',
'TEMPORARYHEADERCONVERSION': 'https://ttlprodapim.azure-api.net/temporaryHeaderConversion',
'SUSPENDHEADERBYPE':'https://ttlprodapim.azure-api.net/suspendHeaderByPE',
'REVOKEHEADERBYPE':'https://ttlprodapim.azure-api.net/revokeHeaderByPE',


//VOICE MODULE
	//TM
	'GETENTITYNAME': 'https://ttlprodapim.azure-api.net/Getentityname',
	'POSTVOICENEWHEADERREGTM': 'https://ttlprodapim.azure-api.net/Insertvoicehdrbytm',
	'VOICEHEADERFILTERDET': 'https://ttlprodapim.azure-api.net/VoiceHeaderFilterDet',
	'GETVOICEHEADERDETAILSBYURN': 'https://ttlprodapim.azure-api.net/Getvoiceheaderdetbyurn',
	'POSTVOICENEWHEADERMODTM': 'https://ttlprodapim.azure-api.net/voiceheaderupdatetm',
	'EXPORTTMLISTCSV': 'https://ttlprodapim.azure-api.net/ExportTmListcsv',

	//PE
	'GETVOICEHEADERREGPE': 'https://ttlprodapim.azure-api.net/Getvoiceheaderdet',
	'POSTVOICENEWHEADERREGPE': 'https://ttlprodapim.azure-api.net/Insertvoicehdrbype',
	'VOICEHEADERPEFILTERDET': 'https://ttlprodapim.azure-api.net/VoiceHeaderpeFilterDet',
	'FILEDOWNLOADNOW': 'https://ttlprodapim.azure-api.net/Filedownloadnow',
	'FETCHVOICEHDRFORPE': 'https://ttlprodapim.azure-api.net/Fetchvoiceheaderforpe',
	'GETVOICESUSPENSION': 'https://ttlprodapim.azure-api.net/VoiceSuspensionReactivation',
	'EXPORTPELISTCSV': 'https://ttlprodapim.azure-api.net/ExportPeListcsv',

	'VOICETEMPLATEREGISTRATION': 'https://ttlprodapim.azure-api.net/Voicetemplateregbype',
	'VOICETEMPLATEMODIFICATION': 'https://ttlprodapim.azure-api.net/Voicetemplatemodbype',
	'UPDATEVOICETEMPLATE': 'https://ttlprodapim.azure-api.net/updateVoiceTemplate',
	'GETVOICECONTENTENTITYDETAILSBYPE': 'https://ttlprodapim.azure-api.net/getVoiceContentEntityDetailsbype',
	'GETVOICEPETEMPLATESUMMARYMONGO': 'https://ttlprodapim.azure-api.net/getVoicepeTemplateSummaryMongo',
	'VOICETEMPLATEPEFILTER': 'https://ttlprodapim.azure-api.net/VoiceTemplatepeFilter',
	'DOWNLOADVOICETEMPLATEBYPE': 'https://ttlprodapim.azure-api.net/downloadVoiceTemplatesbype',
	'GETACTIONBYPE': 'https://ttlprodapim.azure-api.net/GetActionbype',
	'GETVOICETEMPLATEDETAILS': 'https://ttlprodapim.azure-api.net/getVoiceTemplateDetails',
	'GETVOICETEMPLATEFILEDOWNLOAD': 'https://ttlprodapim.azure-api.net/voicetemplatefiledownload',
	'VOICEENTITYMODIFICATION': 'https://ttlprodapim.azure-api.net/VoiceEntityModification',

	//'VOICEHEADERLISTFORPE': 'https://ttlprodapim.azure-api.net/VoiceHeaderListforPE',
	//'VOICETEMPLATEPEFILTERDET': 'https://ttlprodapim.azure-api.net/voicetemplatepefilterdet',

	//VOICE SERVICE HEADER
	//PE SIDE
	'GETTMDET': 'https://ttlprodapim.azure-api.net/getTmDetails',
	'POSTVOICESERVICENEWHEADERREGPE': 'https://ttlprodapim.azure-api.net/Insertvoiceservicehdrbype',
	'VOICESERVICEHEADERFILTERDET': 'https://ttlprodapim.azure-api.net/Voiceserviceheaderfilterdet',
	'EXPORTSERVICEHEADERPELISTCSV': 'https://ttlprodapim.azure-api.net/ExportServiceHeaderpeListCSV',
	'GETVOICESERVICEHEADERBYURN': 'https://ttlprodapim.azure-api.net/getVoiceServiceHeaderByUrn',
	'VOICESERVICEFILEDOWNLOAD': 'https://ttlprodapim.azure-api.net/voiceServiceFileDownload',
	'POSTVOICESERVICEHEADERMODPE': 'https://ttlprodapim.azure-api.net/voiceServiceModPE',
	'VOICESERVICESUSPENSION': 'https://ttlprodapim.azure-api.net/voiceServiceSuspension',

	//TM SIDE
	'VOICESERVICEHEADERTMWL': 'https://ttlprodapim.azure-api.net/voiceServiceHeaderTMWL',
	'GETVOICESERVICEHEADERTM': 'https://ttlprodapim.azure-api.net/getvoiceServiceHeaderTM',
	'POSTVOICESERVICEHEADERTM': 'https://ttlprodapim.azure-api.net/postvoiceServiceHeaderTM',
	'EXPORTSERVICEHEADERTMLISTCSV': 'https://ttlprodapim.azure-api.net/downloadTmVoiceServiceListCSV',

	//Url Registration by PE
    'URLREGISTERBYPE': 'https://ttlprodapim.azure-api.net/urlRegisterationByPE',
    'URLREGISTERLIST': 'https://ttlprodapim.azure-api.net/urlregisterlist',
    'DOWNLOADURLSUMMARYPE': 'https://ttlprodapim.azure-api.net/downloadurllistpe',
    'URLFILEDOWNLOADBLOB': 'https://ttlprodapim.azure-api.net/urlfiledownloadblob',

	//pe side - petm binding
	'PETMBINDINGCREATECHAIN': 'https://ttlprodapim.azure-api.net/petmbindingcreatechain',
	'PETMBINDINGLIST':'https://ttlprodapim.azure-api.net/petmbindinglist',
	'GETTMNAME':'https://ttlprodapim.azure-api.net/gettmname',
	'PEACTIONFORBINDING': 'https://ttlprodapim.azure-api.net/peactionforbinding',
	'DOWNLOADPETMCSVFILE': 'https://ttlprodapim.azure-api.net/downloadPeTmWorklist',
	'UTMGENERATEOTP':'https://ttlprodapim.azure-api.net/utmgenerateOTP',
	'UTMVERIFYOTP':'https://ttlprodapim.azure-api.net/utmverifyOTP',
	//TMTATD side - petm binding
	'PETMBINDINGLIST_TMTATD':'https://ttlprodapim.azure-api.net/petmbindinglist_tmtatd',
	'TMTATDACTIONFORBINDING':'https://ttlprodapim.azure-api.net/tmtatdactionforbinding',
	'EXPORTTMTATDLIST':'https://ttlprodapim.azure-api.net/exporttmtatdlist',
	
	//entity renewal payment Pradnya
	'ENTITYKYCUPDATION': 'https://ttlprodapim.azure-api.net/entityKycUpdation',

	ROLE: {
		'USER_TRACKCOMPLAINTS': 'https://ttlprodapim.azure-api.net/query/GetsubcriberComplaintsByMobileNoComplaintNo/',
		'TRAI_TRACKCOMPLAINTS': 'https://ttlprodapim.azure-api.net/query/GetAllDNDComplaints'
	},
	OTPDIR: {

		'8779789597': 'kk0072958@techmahindra.com',
		'9524025264': 'ss00363892@techmahindra.com',
		'8097131990': 'sk00434028@techmahindra.com',
		'9884880309': 'gk00533482@techmahindra.com',
	}
};

export const IgnoreAPIList: any = [
	'login',
	'Getusername'
];

export const CacheAPIList: any = [
	'Profile'
];
